export enum StockSymbolStatusEnum {
    ACTIVE              = 1,
    ACTIVE_LIMITED      = 2,
}
